import DocumentHeader from './DocumentHeader';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from '../../../../../store/actions';

const mapStateToProps = state => ({
    library: state.library,
    user: state.user,
    topics: state.topics
});

const mapDispatchToProps = dispatch => bindActionCreators({
    upload: actions.library.upload,
    clearUploadList: actions.library.clearUploadList,
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DocumentHeader);